export const iconFontAwesomeMathematicsXmark = (
	<i className="fa-solid fa-xmark"></i>
);
